class Translator {
  constructor(language = 'EN') {
    this.language = language;
    this.translations = {
      'EN': {
        'WELCOME_STRING': 'Welcome to CostingWizard',
        'PROFESSIONAL_SOLUTION': 'Professional Cost Management Solution',
        'GET_STARTED': 'Get Started',
        'FEATURE_TITLE': 'Why Professionals Love Our Costing App 🚀',
        'FEATURE_1_TITLE': 'Always Backed Up in the Cloud',
        'FEATURE_1_DESC': 'Your data is safely stored in the cloud — no risk of losing quotes, and always available when you need it.',
        'FEATURE_2_TITLE': 'Export to PDF & Excel Instantly',
        'FEATURE_2_DESC': 'Create professional quote documents and export them to PDF, Excel, or CSV in one tap — ready to share or print.',
        'FEATURE_3_TITLE': 'Fast & Accurate Costing',
        'FEATURE_3_DESC': 'Enter project details and let the app do the math. From simple to complex jobs, get instant total costs without spreadsheets.',
        'FEATURE_4_TITLE': 'Custom Resources & Fixed Items',
        'FEATURE_4_DESC': 'Use your own materials and resource conversions, or set fixed-cost items like prefab doors or rentals — it\'s all flexible.',
        'FEATURE_5_TITLE': 'Reuse Items Across Projects',
        'FEATURE_5_DESC': 'Build a library of items you use often and add them to new projects in seconds — no need to start from scratch.',
        'FEATURE_6_TITLE': 'Looks Professional, Every Time',
        'FEATURE_6_DESC': 'Quotes are clean, organized, and clear — so clients trust you and you win more jobs.',
        'FEATURE_7_TITLE': 'Native App for iOS and Android',
        'FEATURE_7_DESC': 'Download the app directly from the App Store or Google Play — optimized for phone and tablet.',
        'FEATURE_8_TITLE': 'Built for the Real World',
        'FEATURE_8_DESC': 'Supports real construction workflows — use sections, chapters, and quantity multipliers to reflect how you actually work.',
        'FEATURE_9_TITLE': 'Everything Syncs Automatically',
        'FEATURE_9_DESC': 'Whether you\'re on-site or in the office, your changes are synced in real time — no saving, no stress.',
        'SESSION_EXPIRED': 'Your session has expired. Please log in again.',
        'HOME': 'Home',
        'BLOG': 'Blog',
        'USER_GUIDE': 'User Guide',
        'REGISTER': 'Register',
        'LOGIN': 'Login',
        'DASHBOARD': 'Dashboard',
        'POSTS': 'Posts',
        'SUBSCRIPTION': 'Subscription',
        'LOGOUT': 'Logout',
        'PROFILE': 'Profile',
        'MY_ACCOUNT': 'My Account',
        'USER': 'User',
        'GO_TO': 'Go to',
        // Login Dialog
        'LOGIN_DIALOG_TITLE': 'Login',
        'EMAIL_ADDRESS': 'Email Address',
        'PASSWORD': 'Password',
        'REMEMBER_ME': 'Remember me',
        'FORGOT_PASSWORD': 'Forgot Password?',
        'INVALID_EMAIL': 'Please enter a valid email address',
        'USER_NOT_FOUND': 'No account found with this email address',
        'WRONG_PASSWORD': 'Incorrect password. Try again, or click on "Forgot Password?" to reset it.',
        'USER_DISABLED': 'Your account has been disabled. Please contact support.',
        'TOO_MANY_REQUESTS': 'Too many failed login attempts. Please try again later or reset your password.',
        'LOGIN_FAILED': 'An error occurred during login. Please try again.',
        'PASSWORD_RESET_SENT': 'A password reset link has been sent to your email address.',
        'MISSING_EMAIL': 'Please enter your email address before requesting a password reset.',
        'PASSWORD_RESET_ERROR': 'An error occurred while sending the password reset email. Please try again.',
        // Register Dialog
        'REGISTER_DIALOG_TITLE': 'Register',
        'REPEAT_PASSWORD': 'Repeat Password',
        'TERMS_OF_SERVICE': 'I agree to the terms of service',
        'TERMS_OF_SERVICE_ERROR': 'In order to create an account, you have to accept our terms of service.',
        'ACCOUNT_CREATED': 'Your account has been successfully created! You can now log in.',
        'REGISTRATION_FAILED': 'An error occurred during registration. Please try again.',
        'REGISTRATION_DISABLED': 'Registration is currently disabled. Please try again later.',
        'CONFIGURATION_ERROR': 'Authentication service is not properly configured. Please contact support.',
        'EMAIL_ALREADY_IN_USE': 'This email is already registered. Please use a different email or try logging in.',
        'PASSWORD_TOO_SHORT': 'Create a password at least 6 characters long.',
        'PASSWORDS_DONT_MATCH': 'Your passwords dont match.',
        'BACK': 'Back',
        'PRICING_TITLE': 'Pricing Plans',
        'PRICING_SUBTITLE': 'Select the plan that best fits your business needs',
        'TERMS_CONDITIONS': 'Terms & Conditions',
        'IMPORT_SPREADSHEET': 'Import Spreadsheets',
        'IMPORT_CW_FILE': 'Import CW File',
      },
      'HE': {
        'WELCOME_STRING': 'למה לבזבז שעות על אקסלים ותוכנות מסורבלות?',
        'PROFESSIONAL_SOLUTION': 'קוסטינג ויזארד הוא הפתרון החכם והנוח ליצירת הצעות מחיר וכתבי כמויות – במהירות, בקלות, ובצורה מקצועית.\n\n✅ יצירת פרויקטים עם בינה מלאכותית\n✅ חישוב כמויות אוטומטי\n✅ ממשק פשוט ונגיש מכל מכשיר\n✅ שמירה בענן וגישה מכל מקום\n✅ יצוא ל-PDF ו-Excel בלחיצה\n✅ מושלם לאנשי מקצוע בשטח',
        'CALL_TO_ACTION': 'הרשמה בחינם !',
        'GET_STARTED': 'לחצו כאן להורדה בחינם',
        'FEATURE_TITLE': 'למה אנשי מקצוע אוהבים את אפליקציית התמחירים שלנו 🚀',
        'FEATURE_1_TITLE': 'גיבוי אוטומטי בענן',
        'FEATURE_1_DESC': 'הנתונים שלך מאוחסנים בבטחה בענן - ללא סיכון לאיבוד הצעות מחיר, ותמיד זמינים כשצריך.',
        'FEATURE_2_TITLE': 'ייצוא מיידי ל-PDF ו-Excel',
        'FEATURE_2_DESC': 'צור מסמכי הצעת מחיר מקצועיים וייצא אותם ל-PDF, Excel בלחיצה אחת - מוכנים לשיתוף או הדפסה.',
        'FEATURE_3_TITLE': 'תמחור מהיר ומדויק',
        'FEATURE_3_DESC': 'הזן פרטי פרויקט ותן לאפליקציה לעשות את החישובים. מפרויקטים פשוטים למורכבים, קבל עלויות כוללות מיידיות ללא צורך בגיליונות אקסל.',
        'FEATURE_4_TITLE': 'משאבים מותאמים ופריטים קבועים',
        'FEATURE_4_DESC': 'השתמש בחומרים והמרות משאבים משלך, או הגדר פריטים בעלות קבועה כמו דלתות מוכנות או השכרות - הכל גמיש.',
        'FEATURE_5_TITLE': 'שימוש חוזר בפריטים בין פרויקטים',
        'FEATURE_5_DESC': 'בנה ספרייה של פריטים שאתה משתמש בהם לעתים קרובות והוסף אותם לפרויקטים חדשים תוך שניות - אין צורך להתחיל מאפס.',
        'FEATURE_6_TITLE': 'מראה מקצועי, בכל פעם',
        'FEATURE_6_DESC': 'הצעות המחיר נקיות, מאורגנות וברורות - כך שהלקוחות סומכים עליך ואתה זוכה ביותר עבודות.',
        'FEATURE_7_TITLE': 'אפליקציה מקורית ל-iOS ו-Android',
        'FEATURE_7_DESC': 'הורד את האפליקציה ישירות מה-App Store או Google Play - מותאמת לטלפון וטאבלט.',
        'FEATURE_8_TITLE': 'נבנה לעולם האמיתי',
        'FEATURE_8_DESC': 'תומך בתהליכי עבודה אמיתיים בבנייה - השתמש בסעיפים, פרקים ומכפילי כמויות כדי לשקף איך אתה עובד בפועל.',
        'FEATURE_9_TITLE': 'הכל מסתנכרן אוטומטית',
        'FEATURE_9_DESC': 'בין אם אתה באתר או במשרד, השינויים שלך מסתנכרנים בזמן אמת - אין צורך בשמירה, אין סטרס.',
        'SESSION_EXPIRED': 'הפגישה שלך פגה. אנא התחבר שוב.',
        'HOME': 'בית',
        'BLOG': 'בלוג',
        'USER_GUIDE': 'מדריך שימוש',
        'REGISTER': 'הרשמה',
        'LOGIN': 'התחברות',
        'DASHBOARD': 'לוח בקרה',
        'POSTS': 'פוסטים',
        'SUBSCRIPTION': 'מנוי',
        'LOGOUT': 'התנתק',
        'PROFILE': 'פרופיל',
        'MY_ACCOUNT': 'החשבון שלי',
        'USER': 'משתמש',
        'GO_TO': 'עבור ל',
        // Login Dialog
        'LOGIN_DIALOG_TITLE': 'התחברות',
        'EMAIL_ADDRESS': 'כתובת אימייל',
        'PASSWORD': 'סיסמה',
        'REMEMBER_ME': 'זכור אותי',
        'FORGOT_PASSWORD': 'שכחת סיסמה?',
        'INVALID_EMAIL': 'אנא הזן כתובת אימייל תקינה',
        'USER_NOT_FOUND': 'לא נמצא חשבון עם כתובת אימייל זו',
        'WRONG_PASSWORD': 'סיסמה שגויה. נסה שוב, או לחץ על "שכחת סיסמה?" כדי לאפס אותה.',
        'USER_DISABLED': 'החשבון שלך הושבת. אנא צור קשר עם התמיכה.',
        'TOO_MANY_REQUESTS': 'יותר מדי ניסיונות התחברות כושלים. אנא נסה שוב מאוחר יותר או אפס את הסיסמה שלך.',
        'LOGIN_FAILED': 'אירעה שגיאה במהלך ההתחברות. אנא נסה שוב.',
        'PASSWORD_RESET_SENT': 'קישור לאיפוס סיסמה נשלח לכתובת האימייל שלך.',
        'MISSING_EMAIL': 'אנא הזן את כתובת האימייל שלך לפני בקשת איפוס סיסמה.',
        'PASSWORD_RESET_ERROR': 'אירעה שגיאה בשליחת אימייל איפוס הסיסמה. אנא נסה שוב.',
        // Register Dialog
        'REGISTER_DIALOG_TITLE': 'הרשמה',
        'REPEAT_PASSWORD': 'חזור על הסיסמה',
        'TERMS_OF_SERVICE': 'אני מסכים לתנאי השימוש',
        'TERMS_OF_SERVICE_ERROR': 'על מנת ליצור חשבון, עליך לקבל את תנאי השימוש שלנו.',
        'ACCOUNT_CREATED': 'החשבון שלך נוצר בהצלחה! כעת תוכל להתחבר.',
        'REGISTRATION_FAILED': 'אירעה שגיאה במהלך ההרשמה. אנא נסה שוב.',
        'REGISTRATION_DISABLED': 'ההרשמה כרגע מושבתת. אנא נסה שוב מאוחר יותר.',
        'CONFIGURATION_ERROR': 'שירות האימות אינו מוגדר כראוי. אנא צור קשר עם התמיכה.',
        'EMAIL_ALREADY_IN_USE': 'כתובת אימייל זו כבר רשומה. אנא השתמש בכתובת אחרת או נסה להתחבר.',
        'PASSWORD_TOO_SHORT': 'צור סיסמה באורך של לפחות 6 תווים.',
        'PASSWORDS_DONT_MATCH': 'הסיסמאות אינן תואמות.',
        'BACK': 'חזרה',
        'PRICING_TITLE': 'תוכניות תמחור',
        'PRICING_SUBTITLE': 'בחר את התוכנית המתאימה ביותר לצרכי העסק שלך',
        'TERMS_CONDITIONS': 'תנאים והגבלות',
        'FEATURE_10_TITLE': '🧠 הרחב ושפר פרויקטים בעזרת בינה מלאכותית',
        'FEATURE_10_DESC': 'הרחב ושפר את הפרויקטים הקיימים שלך בעזרת בינה מלאכותית. הוסף פרטים, פרקים, סעיפים ומשאבים לכל פרויקט תוך שניות, חוסך זמן ומבטיח תוצאות מקצועיות.',
        'IMPORT_SPREADSHEET': 'ייבוא גיליונות אקסל',
        'IMPORT_CW_FILE': 'ייבוא קובץ CW',
      }
    };
  }

  setLanguage(language) {
    if (this.translations[language]) {
      this.language = language;
    }
  }

  getString(key) {
    return this.translations[this.language]?.[key] || this.translations['EN'][key] || key;
  }

  static getAvailableLanguages() {
    return ['EN', 'HE'];
  }
}

export default Translator; 